export enum DATA_TEST {
  result_root = 'result_root',
  result_icon_root = 'result_icon_root',
  result_icon = 'result_icon',
  result_illustration = 'result_illustration',
  result_title = 'result_title',
  result_subtitle = 'result_subtitle',
  result_actions = 'result_actions',
  result_button = 'result_button',
  result_default_status_icon = 'result_default_status_icon'
}
